/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:f247d92e-ae35-4bbc-8e87-041deb662e3e",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_7j5LFOedv",
    "aws_user_pools_web_client_id": "6ffibplo4a4t7esihcvqblo0s6",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "testapi",
            "endpoint": "https://hefgiujfb9.execute-api.eu-central-1.amazonaws.com/dev",
            "region": "eu-central-1"
        }
    ]
};


export default awsmobile;
